import { useMemo } from 'react';
import { useSelf } from 'App/components/hooks/appHooks';
import { PageIframeInit } from './PageIframe';

/**
 * Builds the `init` payload posted into a sandboxed Page iframe from the
 * current session. `clientId` scopes the page to a company so its
 * `useAccount()` hook resolves; `orderId` scopes it to an order so `useOrder()`
 * resolves. Pass `null` for either when the host isn't scoped to that entity.
 *
 * Shared by every Page host (standalone `PageView`, the company-card embed,
 * the order-modal embed, the authoring preview) so the payload shape stays in
 * one place.
 */
export function usePageIframeInit(clientId: number | null, orderId: number | null = null): PageIframeInit {
	const self = useSelf();
	const language: string | null = (self as { language?: string } | null)?.language ?? null;

	return useMemo<PageIframeInit>(
		() => ({
			userId: self?.id ?? null,
			clientId,
			orderId,
			language,
			currentRoute: typeof window !== 'undefined' ? window.location.pathname : null
		}),
		[self?.id, language, clientId, orderId]
	);
}
